import React, { useState, createContext, useContext, ReactNode, useEffect } from "react";
import { config } from "../config";

const HeaderMenu = createContext<any>({});
interface AddressData {
  firstName?: string;
  lastName?: string;
  line1?: string;
  line2?: string;
  city?: string;
  postalCode?: string;
  country?: string;
  countrySubdivision?: string;
  countryName?: string;
  emailAddress?: string;
}
interface iOrderDetails {
  cart: { billingAddress?: AddressData; paymentOption?: { [key: string]: any }; taxExemption?: { companyName: string; vatNo: string }; };
}
export default function LoginWrapper({
  children,
}: {
  children?: ReactNode;
}) {
  const [loginStatus, setLoginStatus] = useState<any>();
  const [itemsInCart, setItemsInCart] = useState<any>();
  const [orderSubmit, setOrderSubmit] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [cartCategory, setCartCategory] = useState<string>("");
  const [brand, setBrand] = useState<string>("");
  const [isThanks, setIsThanks] = useState<boolean>(false);
  const [isVerify, setIsVerify] = useState<boolean>(false);
  const [orderFlag, setOrderFlag] = useState<boolean>(false);
  const [order, setOrder] = useState<iOrderDetails>();
  const [sourceData, setSourceData] = useState<{}>();
  const [deviceFingerprintUuid, setDeviceFingerprintUuid] = useState<string>("");
  const value = {
    order,
    setOrder,
    orderSubmit,
    setOrderSubmit,
    itemsInCart,
    setItemsInCart,
    loginStatus,
    setLoginStatus,
    orderFlag,
    setOrderFlag,
    isThanks,
    setIsThanks,
    isVerify,
    setIsVerify,
    sourceData,
    setSourceData,
    isDownload,
    setIsDownload,
    cartCategory,
    setCartCategory,
    brand,
    setBrand,
    deviceFingerprintUuid,
    setDeviceFingerprintUuid
  };
  useEffect(() => {
    setItemsInCart(value.itemsInCart);
  }, [itemsInCart, value.itemsInCart]);
  return (<HeaderMenu.Provider value={value}> {children} </HeaderMenu.Provider>);
}

export function useHeaderMenu() {
  return useContext(HeaderMenu);
}

// Silent Login Session Management Functions
const crossOriginPageUrl = config.crossOriginPageUrl;

//Read Silent Login Session
export const readLoginSession = async () => {
  return new Promise((resolve, reject) => {
    const { origin: targetOrigin } = new URL(crossOriginPageUrl);

    const iframe = document.createElement('iframe');
    iframe.hidden = true;
    iframe.src = crossOriginPageUrl;

    // Set a timeout to reject if no response after 5 seconds
    const timeout = setTimeout(() => {
      window.removeEventListener('message', responseHandler);
      iframe.parentNode?.removeChild(iframe);
      reject(new Error('Timeout: No response from cross-origin page'));
    }, 10000);

    function responseHandler(event) {
      if (event.origin === targetOrigin) {
        clearTimeout(timeout);
        window.removeEventListener('message', responseHandler);
        iframe.parentNode?.removeChild(iframe);
        console.log('Received message from iframe:', event.data);
        return resolve(event.data);
      }
    }

    // Listener to capture the response from the iframe
    window.addEventListener('message', responseHandler);

    iframe.onload = () => {
      console.log('Iframe loaded, sending read message to:', targetOrigin);
      iframe.contentWindow?.postMessage({ type: 'read' }, targetOrigin);
    }

    iframe.onerror = () => {
      clearTimeout(timeout);
      window.removeEventListener('message', responseHandler);
      iframe.parentNode?.removeChild(iframe);
      reject(new Error('Failed to load cross-origin iframe'));
    };

    // Appending the iframe triggers the request
    document.body.appendChild(iframe);
  });
}

//Write Silent Login Session
export const writeLoginSession = (login_hint: string, idp_id: string, timestamp: string, sub: string) => {
  const { origin: targetOrigin } = new URL(crossOriginPageUrl);

  const iframe = document.createElement('iframe');
  iframe.hidden = true;
  iframe.src = crossOriginPageUrl;

  iframe.onload = () => {
    const message = { type: 'write', login_hint, idp_id, timestamp, sub };
    iframe.contentWindow?.postMessage(message, targetOrigin);
  }

  document.body.appendChild(iframe);
}

//Delete Silent Login Session
export const deleteLoginSession = () => {
  return new Promise((resolve, reject) => {
    const { origin: targetOrigin } = new URL(crossOriginPageUrl);

    const iframe = document.createElement('iframe');
    iframe.hidden = true;
    iframe.src = crossOriginPageUrl;

    // Set a timeout to reject if no response after 5 seconds
    const timeout = setTimeout(() => {
      window.removeEventListener('message', responseHandler);
      iframe.parentNode?.removeChild(iframe);
      reject(new Error('Timeout: No response from cross-origin page'));
    }, 5000);

    function responseHandler(event) {
      if (event.origin === targetOrigin) {
        clearTimeout(timeout);
        window.removeEventListener('message', responseHandler);
        iframe.parentNode?.removeChild(iframe);
        console.log('Received delete confirmation from iframe:', event.data);
        return resolve(event.data);
      }
    }

    // Listener to capture the response from the iframe
    window.addEventListener('message', responseHandler);

    iframe.onload = () => {
      console.log('Iframe loaded, sending delete message to:', targetOrigin);
      iframe.contentWindow?.postMessage({ type: 'delete' }, targetOrigin);
    }

    iframe.onerror = () => {
      clearTimeout(timeout);
      window.removeEventListener('message', responseHandler);
      iframe.parentNode?.removeChild(iframe);
      reject(new Error('Failed to load cross-origin iframe'));
    };

    // Appending the iframe triggers the request
    document.body.appendChild(iframe);
  });
}